import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const datacenter = {
  namespaced: true,

  state: {
    co_data: "", // 控制目标数据
    cc_data: "", // 控制措施数据
    cr_data: "", // 控制措施落实点
    roc_data: "", // 控制目标与控制措施间关系 
    rcr_data: "" // 控制措施与控制措施落实点间关系
  },

  mutations: {
    setCoData: (state, para) => {
      Vue.set(state, 'co_data', para)
    },
    setCcData: (state, para) => {
      Vue.set(state, 'cc_data', para)
    },
    setCrData: (state, para) => {
      Vue.set(state, 'cr_data', para)
    },
    setRocData: (state, para) => {
      Vue.set(state, 'roc_data', para)
    },
    setRcrData: (state, para) => {
      Vue.set(state, 'rcr_data', para)
    }
  },
  actions: {
    setCoData: (context, para) => {
      context.commit("setCoData", para)
    },
    setCcData: (context, para) => {
      context.commit("setCcData", para)
    },
    setCrData: (context, para) => {
      context.commit("setCrData", para)
    },
    setRocData: (context, para) => {
      context.commit("setRocData", para)
    },
    setRcrData: (context, para) => {
      context.commit("setRcrData", para)
    }
  }
}